import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isUndefined } from 'util';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'app-user-data-input',
  templateUrl: './user-data-input.component.html',
  styleUrls: ['./user-data-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserDataInputComponent),
      multi: true
    }
  ]
})
export class UserDataInputComponent implements ControlValueAccessor {

  @Input() label: string;
  @Input() set invalidInput(invalidInput: boolean) {
    this.isInvalidInput = coerceBooleanProperty(invalidInput);
  }
  isInvalidInput = false;

  @Input() set marginTop(marginTop: boolean) {
    this.notMarginTop = coerceBooleanProperty(marginTop);
  }
  notMarginTop = true;
@Input() placeholder: string;
  value: string;
  disabled: boolean;
  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(newValue: string): void {
    this.value = newValue ? newValue : '';
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
